module.exports = __webpack_public_path__ + "static/media/catchup_billboard_WideScreen.c9690738.png";